import {stringApp} from 'constant';
import {langEn} from 'screens/MainScreen/ChangeCMNDtoCCCDScreen/lang';
import {convertNumber} from 'utils';

export default {
  footerapp: {
    OverviewScreen: `Dashboard`,
    TransactionScreen: `Transactions`,
    InvestmentScreen: `Return`,
    AssetScreen: `Asset`,
    ProfileScreen: `Account`,
  },

  splashscreen: {
    hi: `Welcome to ${stringApp.companyName}`,
    continue: `Next`,
  },

  loginscreen: {
    login: `Log in`,
    saveusername: `Save`,
    forgotpass: `Forgot Password?`,
    signuptitle: `You do you have an account? `,
    signup: `Register now!`, // [3, 4]
    accountplacehoder: `Phone number`, // [3, 4]
    passwordplacehoder: `Password`, // [3, 4]
    fincorp: `${stringApp.companyName}`, // [3, 4]
    thefintechdeveloper: `thefintechdeveloper`, // [3, 4]
    welcome: `Welcome to ${stringApp.appName}`, // [3, 4]
    tendangnhap: `Username`, // [3, 4]
    matkhau: `Password`, // [3, 4]
    kichhoattaikhoan: `Account activation`, // [3, 4]
    warning: `Nếu Nhà đầu tư có hơn 01 tài khoản, liên hệ DFVN để được hướng dẫn`,
    placeholderPhone: 'Phone number',
  },

  reviewinfoscreen: {
    hosocanhan: `Profile`, // [3, 4]
    thongtincanhan: `Personal information`, // [3, 4]
    hoantathosodangky: `Full submission`, // [4, 5]
    thongtintaikhoannganhang: `Bank account information`, // [5, 6]
    tenchutaikhoan: `Account name`, // [5, 6]
    sotaikhoan: `Account number`, // [5, 6]
    tennganhang: `Bank name`, // [5, 6]
    chinhanh: `Branch`, // [5, 6]
    thongtinnhadautu: `1. Investor information`, // [5, 6]
    hoten: `Full Name`, // [5, 6]
    gioitinh: `Gender`, // [5, 6]
    ngaysinh: `Date of birth`, // [5, 6]
    quoctich: `Country`, // [5, 6]
    email: `Email`, // [5, 6]
    sodienthoai: `Phone`, // [5, 6]
    thongtingiayto: `2. ID Card / Securities Trading code`, // [5, 6]
    note: `Note: The stock trading code is only for foreigners.`, // [5, 6]
    loaigiayto: `Type of document`, // [6, 7]
    sohieugiayto: `Document number`, // [6, 7]
    ngaycap: `Issued date`, // [7, 8]
    noicap: `Issued by`, // [7, 8]
    taihinhanh: `Upload your ID `, // [7, 8]
    thongtindiachi: `Address information`, // [7, 8]
    diachithuongtru: `1. Permanent address`, // [7, 8]
    quocgia: `Country`, // [7, 8]
    tinhthanhpho: `City/Province`, // [7, 8]
    quanhuyen: `District`, // [7, 8]
    phuongxa: `Ward`, // [7, 8]
    sonhatenduong: `Street name, House No.`, // [7, 8]
    diachilienhe: `2. Contact address`, // [7, 8]
    giongdiachithuongtru: `Same as Permanent address`, // [7, 8]
    diachikhac: `Other address`, // [7, 8]
    trong: ``, // [8, 9]
    dieukhoandieukienmotaikhoan: `Terms and Conditions for opening new account`, // [8, 9]
    dieukhoansudung: `Terms and Conditions`, // [8, 9]
    content: ` `, // [9, 10]
    hoantat: `Complete`, // [10, 11]
    danhgiamucdoruiro: `Risk assessment`, // [10, 11]
  },

  forgotpasswordscreen: {
    forgotpassword: `Forgot Password`, // [10, 11]
    content: `Please enter your registered username and follow the instructions`, // [10, 11]
    continue: `Next`, // [10, 11]
    tendangnhap: `Username`, // [10, 11]
  },

  registerscreen: {
    createaccount: `Create new account`, // [10, 11]
    fullname: `Full Name`, // [10, 11]
    email: `Email`, // [10, 11]
    phonenumber: `Phone number`, // [10, 11]
    userrefcode: `Referral code`, // [10, 11]
    continue: `Next`, // [10, 11]
    tieptuc: `Next`, // [10, 11]
    signintitle: `Have you got account? `, // [10, 11]
    signin: `Log in`, // [10, 12]
    dangnhap: `Login!`, // [12, 13]
    dangki: `Register`, // [12, 13]
    hoantoanmienphivaratdongian: `Free - Simple - Easy`, // [12, 13]
    hotendaydu: `Full Name`, // [12, 13]
    magioithieucuanguoibanhang: `Reference code`, // [12, 13]
    thongtinbatbuoc: `Required information`, // [12, 13]
    tendaydubatbuocnhap: `Full name is required`, // [12, 13]
    saidinhdangemail: `Error- invalid email address`, // [12, 13]
    saisodienthoai: `Error- invalid mobile number`, // [12, 13]
    thongtinkhongduocdetrong: `This field is required`, // [12, 13]
    titletrong: ``, // [12, 13]
    emailkhongduocdetrong: `Email is required `, // [12, 13]
    sodienthoaikhongduocdetrong: `Phone number is required `, // [13, 14]
  },

  activeaccountscreen: {
    kichhoattaikhoan: `Account activation`, // [14, 15]
    titletrong: ``, // [14, 15]
    sodienthoaidadangky: `Registered phone number`, // [14, 15]
    placehoder: `Phone number, exp: 09123456789`, // [14, 15]
    tieptuc: `Next`, // [14, 15]
    contentactive: `Please provide the correct phone number registered for trading account`, // [14, 15]
  },

  setpasswordscreen: {
    craetepass: `Create Password`, // [14, 15]
    baomatthongtincanhan: `Personal information security`, // [14, 16]
    rule: `Minimum length is 6 characters, include lowercase (a-z) and uppercase (A-Z), contain at least 1 number (0-9) or special symbols`, // [14, 16]
    namelogin: `Username`, // [16, 17]
    password: `Password`, // [16, 17]
    repassword: `Retype password`, // [16, 17]
    accept: `Accept`, // [16, 17]
    create: `Register`, // [16, 17]
    dangnhap: `Log in`, // [16, 17]
    taomatkhau: `Create Password`, // [16, 17]
    tendangnhap: `Username`, // [16, 17]
    rule1: `Minimum length is 6 characters and maximum is 40 characters`, // [16, 17]
    rule2: `Include lowercase (a-z) and uppercase (A-Z)`, // [16, 17]
    rule3: `Contain at least 1 number (0-9) or special symbols`, // [17, 18]
    matkhau: `Password`, // [17, 18]
    nhaplaimatkhau: `Retype password`, // [17, 18]
    matkhaubaogom: `Password included:`, // [17, 18]
    tieptuc: `Next`, // [17, 18]
    saidinhdangmatkhau: `Password is invalid rules!`, // [17, 18]
    xacnhanmatkhaukhongdung: `Retype password and Password do not match!`, // [18, 19]
    titletrong: ``, // [18, 19]
    thongtinkhongduocdetrong: `This field is required`, // [18, 19]
    vuilongnhapmatkhau: `Please enter your password`, // [18, 19]
    vuilongnhaplaimatkhau: `Please re-enter your password`, // [18, 19]
    xacthuctaikhoan: `Account verification`, // [18, 19]
  },

  otprequestmodal: {
    confirminformation: `Confirmation Transaction`, // [19, 20]
    content: `Please enter the verification code (OTP) sent to the phone number`, // [19, 20]
    confirm: `Confirm`, // [19, 20]
    resendotp: `Resend OTP`, // [19, 20]
    contenttiming: `OTP code will expire within`, // [19, 20]
    otptimeout: `OTP is expired`, // [20, 21]
    content2: `Please enter the authentication code (OTP) obtained from the ${stringApp.appName} application on the registered device`, // [20, 21]
  },

  loading: `Loading`, // [20, 21]

  profile: {
    taikhoan: `Account`, // [20, 21]
    file: `Profile`, // [21, 22]
    logininfo: `Login information`, // [21, 22]
    changepassword: `Change password`, // [21, 22]
    hosogoc: `Original file`, // [21, 22]
    changeemail: `Change email`, // [21, 22]
    changepermanentaddress: `Change Permanent address`, // [21, 22]
    changeaddress: `Change mail address`, // [21, 22]
    logout: `Log out`, // [21, 22]
    hosomotaikhoan: `Application form`, // [22, 23]
    sotaikhoan: `Account No - `, // [22, 23]
    contentlogininfo: `Are you sure you want to update your editing?`, // [22, 23]
    change: `Change`, // [22, 23]
    email: `Email`, // [22, 23]
    phone: `Mobile phone number`, // [22, 23]
    password: `Password`, // [22, 23]
    userref: `Referral code`, // [23, 24]
    cannotchange: `Cannot change`, // [23, 24]
    chukyso: `Digital signatures`, // [23, 24]
    trangthaihoso: `Document status`, // [23, 24]
    thongtintaikhoan: `Profile`, // [23, 24]
    thaydoimatkhau: `Change password`, // [23, 24]
    thaydoisodienthoai: `Change phone number`, // [23, 24]
    thaydoiemail: `Change email`, // [23, 24]
    hotrokhachhang: `Call center`, // [23, 24]
    hotline: `Hotline`, // [24, 25]
    caidatvabaomat: `Setting & security`, // [24, 25]
    dangxuat: `Log out`, // [24, 25]
    oldpassword: `Old Password`, // [24, 25]
    newpassword: `New Password`, // [24, 25]
    renewpassword: `Confirm New password`, // [24, 25]
    save: `Save`, // [24, 25]
    rulepassword: `Password contains \n* Minimum length is 6\n* Includes lowercase letters (a-z) and uppercase letters (A-Z)\n* Contains at least one number (0-9) or one special character`, // [24, 25]
    oldemail: `Old email`, // [25, 26]
    newemail: `New email`, // [25, 26]
    renewemail: `Confirm new email`, // [25, 26]
    address: `Address No and Street`, // [25, 26]
    placeholderaddress: `Enter address no and street name`, // [25, 26]
    nation: `Country`, // [26, 27]
    city: `Province/City`, // [26, 27]
    district: `District`, // [26, 27]
    commune: `Ward`, // [26, 27]
    emailsaidinhdang: `Email is invalid format`, // [26, 27]
    matkhauchuadumanh: `Your password is not strong.`, // [26, 27]
    saidinhdangmatkhau: `Password is invalid rules!`, // [26, 27]
    xacnhanmatkhaukhongdung: `Retype password and Password do not match!`, // [26, 27]
    titletrong: ``, // [27, 28]
    thongtinkhongduocdetrong: `This field is required`, // [27, 28]
  },

  accountverify: {
    requireeditbank:
      'Required information and bank account details will be used to process the payment for Fund Certificate redemption when the Investor places a sell order.',
    contentdoicmnd: `If investors need to change information, please contact DFVN for instructions.`,
    vnid: 'VNeID/ID Card Image', // [28, 29]
    luuy: `Note : `, // [28, 29]
    thongtintaikhoan: `Account Information`, // [29, 30]
    thongtintaikhoannganhang: `1. Bank account information`, // [29, 30]
    thongtinkhac: `2. Other information`, // [29, 30]
    thongtincanhan: `Personal information`, // [29, 30]
    thongtinnganhang: `Bank account information`, // [29, 30]
    thongtindiachi: `Address information`, // [29, 30]
    xacthuchoantat: `Verification completed`, // [29, 30]
    hopdongdientu: `Registration Form`, // [29, 30]
    vuilongchonquocgia: `Please select a country`, // [29, 31]
    vuilongchontinhthanhpho: `Please select a province/city`, // [29, 31]
    vuilongchonquanhuyen: `Please select a county/district`, // [31, 32]
    vuilongchonphuongxa: `Please select a ward`, // [31, 32]
    chondiachilienhe: `Contact address`, // [31, 32]
    vuilongchondiachilienhe: `Select address`, // [31, 32]
    danhgiamucdoruiro: `Risk assessment`, // [31, 32]
    guithongtin: `Send information`, // [31, 32]
    nghenghiep: `Occupation`, // [31, 32]
    chucvu: `Title`, // [31, 32]
    mucthunhaphangthang: `Monthly income`, // [31, 32]
    nguontiendautu: `Source of investment`, // [31, 32]
    sonhatenduong: `Street name, House No.`, // [31, 32]
    hosogoc: `Original file`, // [32, 33]
    quocgia: `Country`, // [32, 33]
    tinhthanhpho: `City/Province`, // [32, 33]
    tinhthanhphotheodiachilienhe: `City/Province (Contact address)`, // [33, 34]
    quanhuyen: `District`, // [33, 34]
    phuongxa: `Ward`, // [33, 34]
    thongtincongtacvien: 'Register to become a partner', // [34, 35]
    thongtinnhadautu: `1. Investor information`, // [33, 34]
    hoten: `Full Name`, // [33, 34]
    ngaysinh: `Date of birth`, // [33, 34]
    gioitinh: `Gender`, // [34, 36]
    quoctich: `Country`, // [34, 36]
    nam: `Male`, // [34, 36]
    nu: `Female`, // [34, 36]
    email: `Email`, // [34, 36]
    sodienthoai: `Phone number`, // [34, 36]
    thongtincmnd: `2. ID Card / Securities Trading code`, // [34, 36]
    loaigiayto: `Type of document`, // [34, 36]
    sohieugiayto: `Document number`, // [34, 36]
    ngaycap: `Issued date`, // [36, 37]
    cccd: `ID Card`, // [4, 37]
    magiaodichchungkhoan: `Trading Code`, // [36, 37]
    noicap: `Issued by`, // [36, 37]
    taihinhanh: `Upload a picture of your ID Card/Securities Trading code`, // [36, 37]
    notetaihinhanh: `The Identity paper are still valid, have enough light, are original photos, not scanned and copied`, // [36, 37]
    taianhmattruoc: `Upload a photo of the front`, // [37, 38]
    taianhmatsau: `Upload a photo of the back`, // [37, 38]
    vuilongchonloaigiayto: `Please select document type`, // [37, 38]
    chuy: `Note: The stock trading code is only for foreigners.`, // [37, 38]
    tenchutaikhoan: `Account name`, // [37, 38]
    sotaikhoan: `Account number`, // [38, 39]
    tennganhang: `Bank name`, // [38, 39]
    chinhanh: `Branch`, // [38, 39]
    content: `This required information and account information is transferred when the sell order is executed.`, // [38, 39]
    vuilongchonnganhang: `Please select a bank`, // [38, 39]
    vuilongchonchinhanh: `Please select a branch`, // [38, 39]
    diachilienhe: `Contact address`, // [35, 39]
    giongdiachithuongtru: `Same as Permanent address`, // [35, 39]
    diachikhac: `Other address`, // [35, 39]
    diachithuongtru: `Permanent address`, // [35, 39]
    dieukhoan: `Rules`, // [35, 39]
    xacnhanhoantat: `Verification completed`, // [35, 39]
    hoantat: `Complete`, // [35, 40]
    toidongyvoidieukhoantren: `I agree to the terms and conditions.`, // [35, 40]
    contentinhoso: `Please print, sign and mail to the company's address in the contact section!`, // [35, 40]
    tongdongyvoidieukhoanfatca: `I agree to answer: No to all questions related to FATCA`, // [35, 40]
    contentdiachi1: `Once this step is completed, Registration Form will be sent to registered email directly: `, // [40, 41]
    titleconfirm: `To start making transactions, you need to confirm the information and agree to the terms and conditions below:`, // [41, 42]
    contentconfirm: `1.Bản công bố rủi ro khi đầu tư vào quỹ mở.\n\nTôi, Nhà Đầu Tư, đã xem xét các thông tin được cung cấp về quỹ mở, và hiểu quỹ mở là gì.\n
Tôi, Nhà Đầu Tư, hiểu tôi đang tham gia vào một sản phẩm đầu tư tại thị trường chứng khoán Việt Nam, bao gồm cổ phiếu, trái phiếu, và các công cụ tài chính khác. Tôi hiểu rằng các khoản đầu tư vào chứng khoán sẽ chịu tác động từ rủi ro của thị trường, và vì vậy mà có thể thay đổi tăng hoặc giảm giá trị của khoản đầu tư.\n
Mức sinh lời kỳ vọng (nếu có) của Tôi trong các quỹ mở hoàn toàn không được cam kết hay đảm bảo. Vì vậy, Tôi hiểu rằng mức sinh lời thực tế có thể cao hơn hoặc thấp hơn mức sinh lời kỳ vọng hoặc mức sinh lời trong quá khứ của quỹ.\n
Khoản đầu tư vào quỹ mở của Tôi có thể phải chịu thua lỗ nếu các chứng khoán được đầu tư vào không hoạt động hiệu quả hoặc thị trường không thuận lợi. Từ đó Tôi hiểu rằng một phần khoản đầu tư của tôi có thể bị mất mát do mức sinh lời của quỹ không như kỳ vọng.\n
${stringApp.companyName} hoặc đối tác của ${stringApp.companyName} không thể đưa ra bất kỳ cam kết nào về lợi nhuận hay thua lỗ trên khoản đầu tư, cho dù là một cách trực tiếp hay gián tiếp. Tôi hiểu rằng ${stringApp.companyName} và đối tác của ${stringApp.companyName} không chịu và không có bất kỳ nghĩa vụ pháp lý nào phải bồi thường cho bất cứ khoản lỗ nào đối với các khoản đầu tư của Tôi vào quỹ mở.\n\n2.Cam kết của nhà đầu tư khi đầu tư vào quỹ mở\n\nTôi có trách nhiệm am hiểu rõ Bản cáo bạch và Điều lệ của Quỹ mà tôi đăng ký tham gia.\n
Tôi sẽ chịu trách nhiệm cho quyết định đầu tư và chấp nhận các rủi ro đầu tư.\n`,
    save: `Save`, // [41, 43]
    congboruiro: 'CÔNG BỐ RỦI RO VÀ CAM KẾT CỦA NHÀ ĐẦU TƯ.', // Giữ nguyên [43]
    title1: '1. Bản công bố rủi ro khi đầu tư vào quỹ mở.', // Giữ nguyên [43]
    content1: `Tôi, Nhà Đầu Tư, đã xem xét các thông tin được cung cấp về quỹ mở, và hiểu quỹ mở là gì...`, // Giữ nguyên [43]
    title2: '2. Cam kết của nhà đầu tư khi đầu tư vào quỹ mở.', // Giữ nguyên [44]
    content2: `Tôi có trách nhiệm am hiểu rõ Bản cáo bạch và Điều lệ của Quỹ mà tôi đăng ký tham gia...`, // Giữ nguyên [44]
    title3: 'Ngoài ra, đang có thêm một phần nội dung cam kết...', // Giữ nguyên [45]
    content3: `Bằng văn bản này, tôi xác nhận thông tin cung cấp ở trên là đúng, chính xác và đầy đủ...`, // Giữ nguyên [45]
  },

  transactionscreen: {
    saokegiaodich: `Fund Statement`, // [46, 47]
    chonquy: `Select Product`, // [46, 47]
    theothoidiemgiaodich: `Transaction time`, // [46, 47]
    saoke: `Export`, // [46, 47]
    tungay: `From date`, // [46, 47]
    denngay: `To date`, // [46, 47]
    giaodich: `Transactions`, // [46, 47]
    lenhchoxuly: `Pending \norders`, // [46, 47]
    lichsugiaodich: `Transaction history`, // [46, 47]
    lenhchomua: `Subscribe`, // [46, 47]
    lenhchoban: `Redeem`, // [46, 47]
    lenhchochuyendoi: `Switch`, // [46, 47]
    tongsolenh: `Number of Order(s):`, // [47, 48]
    quychuongtrinh: `Fund - Program`, // [47, 48]
    soluong: `Units`, // [47, 48]
    sotienmua: `Amount`, // [47, 48]
    sotienmuavnd: `Subscription amount ${stringApp.currencyEn}`, // [48, 49]
    ngaydatlenh: `Order date`, // [48, 49]
    trangthai: `Status`, // [48, 49]
    nhapmalenh: `Enter order code`, // [48, 49]
    ngay: `Date`, // [48, 49]
    thoidiemgiaodich: `Transaction time`, // [48, 49]
    chuacogiaodich: `You have not created an order yet`, // [48, 49]
    thongtindautu: `Investment information`, // [48, 49]
    quydautu: `Investment fund`, // [48, 49]
    chuongtrinh: `Program`, // [48, 49]
    loailenh: `Order type`, // [48, 49]
    phiengiaodich: `Trading session`, // [49, 50]
    thongtinchuyenkhoan: `Bank transfer information`, // [49, 50]
    taikhoanthuhuong: `Beneficiary account`, // [49, 50]
    tenthuhuong: `Beneficiary`, // [50, 51]
    sotaikhoan: `Account number`, // [50, 51]
    tennganhang: `Bank name`, // [50, 51]
    noidung: `Description`, // [50, 51]
    phuongthucchuyenkhoan: `You are choosing a bank transfer method.`, // [50, 51]
    soccqban: `Units`, // [50, 51]
    soccq: `Units`, // [50, 51]
    ngaymua: `Subscription date`, // [50, 51]
    tgnamgiu: `Holding time`, // [50, 51]
    slban: `Redemption units`, // [50, 51]
    phi: `Fee`, // [50, 51]
    quymuctieu: `Target Fund`, // [50, 51]
    giatriuoctinh: `Estimated value`, // [50, 51]
    socqqchuyendoi: `Units Switch`, // [50, 51]
    tongtien: `Amount`, // [51, 52]
    ngaygiaodich: `Trading date`, // [51, 52]
    malenh: `Code`, // [51, 52]
    nav: `NAV/Unit`, // [51, 52]
    sotien: `Subscription Amount`, // [52, 53]
    navkytruoc: `NAV of Last period`, // [52, 53]
    locgiaodich: `Transaction Filter`, // [52, 53]
    xoa: `Delete`, // [52, 53]
    huy: `Cancel`, // [52, 53]
    apdung: `Apply`, // [52, 53]
    theoloailenh: `Order type`, // [52, 53]
    tatca: `All`, // [52, 53]
    lenhmua: `Subscription Order`, // [52, 53]
    lenhban: `Redemption Order`, // [52, 53]
    lenhmuahoandoi: `Switch-In Order`, // [52, 53]
    lenhbanhoandoi: `Switch-Out Order`, // [52, 53]
    lenhhoandoi: `Switching Order`, // [52, 53]
    toingay: `To date`, // [52, 53]
    taolenhmua: `Subscribe order`, // [52, 53]
    taolenhban: `Redeem order`, // [52, 53]
    taolenhchuyendoi: `Switch order`, // [53, 54]
    dinhky: `SIP`, // [53, 54]
    tinhtrang: `Status`, // [53, 54]
    sotiendangkydautu: `Amount`, // [54, 55]
    sokydaututoithieu: `Min Invested Term`, // [54, 55]
    sokydadautu: `Succeed Term`, // [54, 55]
    sokylientuckhongthamgia: `Missing Term`, // [54, 55]
    kydaututieptheo: `Next term`, // [54, 55]
    copy: `COPY`, // [54, 55]
    nganhang: `Bank`, // [54, 55]
    chinhanh: `Branch`, // [54, 55]
    nguoihuongthu: `Beneficial owner`, // [54, 55]
    lichsukhoplenh: `History Order`, // [54, 55]
    taiphieuxacnhan: `Download confirmation slip`, // [54, 55]
    kydautu: `Period`, // [54, 55]
    sotiendautu: `Amount`, // [54, 55]
    ngaykhoplenh: `Trading session`, // [54, 55]
  },

  settingscreen: {
    caidatvabaomat: `Setting & security`, // [56, 57]
    ngonngu: `Language`, // [56, 57]
    nhanthongbao: `Receive notification`, // [56, 57]
    faceid: `Face ID/Touch ID`, // [56, 57]
    thongbao: `Notification`, // [56, 57]
    content: `Please enter your password to activate this function`, // [56, 57]
    matkhau: `Password`, // [56, 57]
    huy: `Cancel`, // [56, 57]
    xacnhan: `Confirm`, // [56, 57]
    kichhoatthanhcong: `You have successfully activated fingerprint/face login`, // [56, 57]
    xacnhanhuykichhoat: `Are You Sure You Want To Disactivate Touch Id/Face Id`, // [56, 57]
    matkhaucuaquykhachkhongdung: `Password is invalid`, // [57, 58]
    yeucauxoataikhoan: `Account delete request`, // [58, 59]
    yeucauxoa: `Delete request`, // [58, 59]
  },

  supportscreen: {
    hotrokhachhang: `Call center`, // [59, 60]
    cskh: `Customer care`, // [59, 60]
    email: `Email`, // [59, 60]
    facebook: `Facebook`, // [59, 60]
    trungtamchamsockhachhang: `Customer care Center`, // [59, 60]
    chuyenvientrogiup: `Consultant`, // [59, 60]
    hoten: `Full Name`, // [59, 60]
  },

  investmentscreen: {
    dautu: `Invest`, // [59, 60]
    sanpham: `Products`, // [59, 60]
    giadonviquykytruoc: `Current NAV`, // [59, 60]
    ngay: `Date`, // [59, 60]
    dautungay: `Invest now`, // [59, 60]
    giatrihientai: `Market value`, // [59, 60]
    danhsachphiengiaodich: `List of trading sessions`, // [59, 60]
    phiengiaodich: `Trading session`, // [61, 62]
    taolenhmua: `Subscribe order`, // [61, 62]
    thaydoisovoidaunam: `Change to beginning of the year`, // [60, 62]
    taingay: `to date`, // [61, 62]
    denngay: 'to date', // [61, 62]
    Taingay: `at date`, // [61, 62]
    giatriNAVCCQ: `Last unit price of Fund certificate ${stringApp.currencyEn}`, // [61, 62]
    NAVtaingay: `NAV as at`, // [61, 62]
    tangtruongNAVCCQ: `NAV/Fund certificate growth - `, // [61, 62]
    NAVcaonhat: `Highest value`, // [61, 62]
    NAVthapnhat: `Lowest value`, // [61, 62]
    khongconoidunghienthi: `No Data`, // [61, 62]
    thang: `Month`, // [61, 62]
    nam: `Year`, // [61, 62]
    tatca: `All`, // [61, 62]
    NAV: `NAV/Unit`, // [61, 63]
    navccq: `NAV/Unit`, // [61, 63]
    thongtinquy: `Fund information`, // [61, 63]
    xemchitiet: `See details`, // [61, 63]
    xemthem: `Show more`, // [61, 63]
  },

  createordermodal: {
    huongdanthanhtoanbangqrcode: `Instructions for payment by QR Code`, // [63, 64]
    giatrimua: `Subscription Value`, // [63, 64]
    nhapmatuvanvien: `Input referral code`, // [63, 64]
    tudongtieptucdautu: `Monthly automatic order`, // [63, 64]
    ngaythanhtoanhangthang: `Start date`, // [63, 64]
    datlenhban: `Redeem order`, // [63, 64]
    datlenhmua: `Subscribe order`, // [63, 64]
    datlenhchuyendoi: `Switch order`, // [63, 64]
    matuvanvien: `Referral code`, // [63, 64]
    xacnhan: `Confirm`, // [63, 64]
    datlenh: `Place Order`, // [64, 65]
    ketqua: `Result`, // [64, 65]
    hoac: `Or`, // [64, 65]
    thanhtoannhanhquaqrcode: `Scan QR to transfer`, // [64, 65]
    huongdanchuyenkhoan: `Transfer instructions`, // [65, 66]
    xemqrcode: `View QR code`, // [65, 66]
    taive: `Download`, // [65, 66]
    motsonganhangchuahotroquetmaqr: `Note: Some banks do not support QR payment yet`, // [65, 66]
    quykhachvuilongdoichieuthongtintruockhichuyenkhoan: `Please check the information before transferring`, // [65, 66]
    quaylai: `Back`, // [65, 66]
    bieuphimua: `Subscription fee`, // [65, 66]
    thoigiandautulientuctoithieu: `Minimum continuous investment period`, // [65, 66]
    thang: `Month`, // [66, 67]
    bieuphichuyendoi: `Switching fee`, // [67, 68]
    bieuphiban: `Redemption fee`, // [67, 68]
    thoigiannamgiu: `Holding time`, // [67, 68]
    ngaybatdauthamgia: `Start date`, // [67, 68]
    tudongtaolenhdinhkyhangthang: `Automatically generate monthly recurring orders`, // [67, 68]
    chonsanpham: `Select product`, // [67, 68]
    chonchuongtrinh: `Select program`, // [67, 68]
    nhapsotienmua: `Please input subscription amount`, // [67, 68]
    sotiendaututoithieu: `Minimum investment amount`, // [67, 68]
    phimua: `Fee`, // [67, 68]
    phichuyendoi: `Switching fee`, // [67, 68]
    xembieuphi: `View fee scheme`, // [67, 68]
    thoidiemdongsolenh: `Cut-off time`, // [67, 68]
    nhadautuvuilongchuyentientruoc: `Please transfer money before`, // [69, 70]
    thoidiemdongsolenhnhantien: `Investor's purchase money must be credited to the Fund's account before`, // [69, 70]
    phiengiaodich: `Trading session`, // [69, 70]
    thongtindautu: `Investment information`, // [69, 70]
    quydautu: `Investment fund`, // [69, 70]
    chuongtrinh: `Program`, // [69, 70]
    loailenh: `Order type`, // [69, 70]
    ngaydatlenh: `Order date`, // [69, 70]
    sotienmua: `Subscription amount`, // [69, 70]
    phuongphapthanhtoan: `Payment methods`, // [69, 70]
    chuyenkhoanquanganhang: `Bank transfer`, // [69, 70]
    vuilongchuyentientruoc: `Investor should transfer money before trading date`, // [69, 70]
    thongtinchuyenkhoan: `Bank transfer information`, // [71, 72]
    luuyttck: `Please copy the correct information to ensure the order is executed.`, // [71, 72]
    tenthuhuong: `Beneficial Owner`, // [71, 72]
    sotaikhoan: `Account number`, // [71, 72]
    nganhang: `Bank`, // [71, 72]
    noidung: `Description`, // [71, 72]
    mua: `Subscribe`, // [71, 72]
    datlenhmuathanhcong: `Your subscription order was successful`, // [71, 72]
    camonquykhachdadautuvao: `Thank you for your investment in`, // [71, 72]
    muathem: `Subscribe Continue`, // [71, 72]
    hoantat: `Complete`, // [71, 72]
    xacnhanthanhtoan: `Payment confirmation`, // [71, 72]
    contentxacnhanthanhtoan: `Investors confirm the payment information for the investment with the following transfer information:`, // [71, 72]
    nhapsoluongban: `Please input redemption units`, // [73, 74]
    soluongtoithieukhongduoi: `Minimum units not less than`, // [73, 74]
    soluongkhadung: `Available Quantity`, // [73, 74]
    ngaymua: `Subscription date`, // [73, 74]
    tgnamgiu: `Holding time`, // [73, 74]
    slban: `Redemption units`, // [73, 74]
    phi: `Fee`, // [73, 74]
    phiban: `Redemption fee`, // [73, 74]
    soluongban: `Redemption units`, // [73, 74]
    ban: `Redeem`, // [73, 74]
    giatriuoctinhsauthuephi: `Estimated value after taxes, fees`, // [73, 74]
    datlenhbanthanhcong: `You have successfully placed a sell order`, // [73, 74]
    camonquykhach: `Thank you`, // [73, 74]
    thongtinccqchuyendoi: `Source Fund Information`, // [74, 75]
    chonccqchuyendoi: `Select the switch fund`, // [75, 76]
    navkitruoc: `NAV of Last period`, // [75, 76]
    soluongchuyendoi: `Units`, // [75, 76]
    thongtinccqmuctieu: `Target Fund Information`, // [75, 76]
    chonccqmuctieu: `Select target fund`, // [75, 76]
    thongtinchuyendoi: `Switch information`, // [75, 76]
    chuyendoi: `Switch`, // [75, 76]
    datlenhchuyendoithanhcong: `You have successfully placed a switch order`, // [75, 76]
    navccqkitruoc: `Current NAV/Units`, // [75, 76]
    tatca: `All`, // [75, 76]
  },

  assetscreen: {
    tongquantaisan: `Property Overview`, // [76, 77]
    sl: `Quantity :`, // [76, 77]
    chitiet: `Detail`, // [76, 77]
    ccq: `Units`, // [76, 77]
    giamua: `Buying NAV`, // [76, 77]
    danhsachlenhmuadangnamgiu: `List of holding subsciption orders`, // [76, 77]
    tongsodanhsach: `Total list:`, // [77, 78]
    quychuongtrinh: `Fund - Program`, // [77, 78]
    phiengiaodich: `Trading session`, // [77, 78]
    tonggiatridangnamgiu: `Total holding value`, // [77, 78]
    tonggiatridangchokhop: `Total pending redemption amount`, // [77, 78]
    tongtaisan: `Total asset`, // [77, 78]
    soluong: `Units`, // [77, 78]
    giatridaututb: `AVG investment`, // [77, 78]
    navkitruoc: `Current NAV`, // [77, 78]
    giatrihientai: `Market value`, // [78, 79]
    loilophantram: `Gain/loss(%)`, // [78, 79]
    loilodong: `Gain/loss(VND)`, // [78, 79]
    lenh: `Command`, // [78, 79]
    chuongtrinh: `Program`, // [78, 79]
    sotkdautu: `Account number`, // [78, 79]
    giatrithitruong: `Market value`, // [79, 80]
    sldonviquy: `Units`, // [79, 80]
    sotiendadautu: `Amount invested`, // [79, 80]
    sotiendadautuconlai: `Remaining invested amount`, // [79, 80]
    ngaygiaodichdautien: `First trading day`, // [79, 80]
    lailodathuchien: `Realized Gain/loss`, // [79, 80]
    lailochuathuchien: `Unrealized Gain/loss`, // [79, 80]
    loilo: `Gain/loss`, // [79, 80]
    tongdautu: `Total investment`, // [79, 80]
  },

  overviewscreen: {
    tongquantaisan: `Property Overview`, // [80, 81]
    tongsocqq: `Total units`, // [80, 81]
    giatrihientai: `Market value`, // [80, 81]
    loilo: `Gain/loss`, // [80, 81]
    banchuacotaisan: `You don't have any assets`, // [80, 81]
    contentnondata: `You need to participate in the investment and make transactions by going to the "Investment" section below`, // [81, 82]
    tonggiatridaututb: `Total investment amount`, // [81, 82]
    sotiendautu: `Total cost of capital`, // [81, 82]
    sotiendautuvnd: `Total cost of capital ${stringApp.currencyEn}`, // [81, 82]
    tongloilo: `Total gain/loss`, // [81, 82]
    taisan: `Asset`, // [82, 83]
    soluongCCQ: `Units`, // [82, 83]
    NAVhientai: `NAV/Unit`, // [82, 83]
    tonggiatridaututrungbinh: `Total cost of capital ${stringApp.currencyEn}`, // [82, 83]
    giamuatrungbinh: `Average buying NAV/Unit`, // [82, 83]
    tonggiatrithitruong: `Total Market Value ${stringApp.currencyEn}`, // [83, 84]
  },

  notificationscreen: {
    thongbao: `Notification`, // [83, 84]
    huy: `Cancel`, // [83, 84]
    xoamucdachon: `Delete selected item`, // [83, 84]
  },

  MiniEkycModal: {
    xacthucthongtin: `Verify information`, // [83, 84]
  },

  controlekyc: {
    dangnhap: `Log in`, // [84, 85]
    xacthucthongtin: `Verify information`, // [84, 85]
    content: `To complete the account opening on ${stringApp.appName}, please follow the steps below to verify your information`, // [84, 85]
    chuphinhmattruoc: `1. Take pictures of the front and back of your ID Card`, // [84, 85]
    chuphinhchandung: `2. Take a portrait photo`, // [85, 86]
    batdau: `Start`, // [85, 86]
    thuchiensau: `Do it later`, // [85, 86]
  },

  digitalsignature: {
    chukyso: `Digital signatures`, // [86, 87]
    xemgiaydkgd: `View BUSINESS REGISTRATION`, // [86, 87]
    uploadanh: `Upload image`, // [86, 87]
    kyso: `Digital signature`, // [86, 88]
    xoa: `Delete`, // [86, 88]
    xacnhan: `Confirm`, // [86, 88]
    contentnoti: `Please sign in the area above`, // [86, 88]
    giaydkgd: `BUSINESS REGISTRATION`, // [86, 88]
    mayanh: `Camera`, // [86, 88]
    thuvien: `Library`, // [86, 88]
    huy: `Cancel`, // [86, 88]
    chonhinhanh: `Select image`, // [86, 88]
    taive: `Download`, // [86, 88]
    hopdongdientu: `Registration Form`, // [86, 88]
    hopdongdientutype2: `Registration Form`, // [86, 88]
    xemtruoc: `Preview`, // [88, 89]
    kydientu: `Sign now`, // [88, 89]
    taichuky: `Upload signature`, // [88, 89]
    chukycuaban: `Your signature`, // [88, 89]
    taihopdongdaky: `Download signed Account Opening Contract.`, // [88, 89]
    taihopdongmotaikhoan: `Download Account Opening Contract.`, // [88, 89]
    contentdownload: `Please preview the information on the Registration Form to open your trading account and make a digital signature by clicking the 'Electronic Sign' button below.`, // [89, 90]
    contentdownload2: `Your registration for opening a trading account has been confirmed electronically. Investors can download the signed trading account registration form by clicking the button below`, // [89, 90]
  },

  feetable: {
    bieuphi: `Tariffs`, // [91, 92]
  },

  alert: {
    hetphiengiaodich: `This session has ended. Please log in again!`,
    capnhathinhanhthanhcong: `Upload image successful`,
    khuonmatkhonghople: `Invalid facial photo. Please try again.`, // Giữ nguyên [92]
    xoataikhoanthanhcong: `Deactivate account is completed`, // [92, 93]
    ngaycap: `The date of issue must not be less than the date of birth`, // [92, 94]
    vuilongchondayduthongtin: `Please fill in full information `, // [92, 93]
    kythanhcong: `Esign complete`, // [92, 93]
    capnhatmucdoruirothanhcong: `Update Risk assessment success`, // [92, 93]
    taochukysothanhcong: `Esign complete`, // [92, 93]
    logout: `Log out`, // [92, 93]
    dinhdanganhkhongphuhop: `The signature image you uploaded is malformed. Please choose image files with the format: .png,.jpg, .jpeg`, // [92, 93]
    desau: `Later`, // [93, 95]
    taithanhcong: `Download complete`, // [93, 95]
    kydientu: `Sign now`, // [95, 96]
    contentlogout: `Are you sure you want to log out?`, // [95, 96]
    dong: `Close`, // [95, 96]
    xoalenh: `Delete order successfully`, // [95, 96]
    doimatkhauthanhcong: `Change password success`, // [95, 96]
    doiemailthanhcong: `Change email success`, // [95, 96]
    capnhatdiachithanhcong: `Update address successfully`, // [95, 96]
    vuilongnhapdayduthongtindiachi: `Please enter full address information`, // [95, 96]
    vuilongnhapdayduthongtincanhan: `Please enter full personal information`, // [95, 96]
    capnhatthongtincanhanthanhcong: `Personal information updated successful`, // [96, 97]
    capnhattaikhoannganhang: `Successfully updated bank account information`, // [97, 98]
    capnhatthongtintaikhoannganhangthanhcong: `Your banking information has been updated succesfully!`,
    dangxuat: `Log out`, // [96, 97]
    lichxong: `Done`, // [97, 99]
    thongbao: `Notification`, // [97, 99]
    dungluongtoida: `Maximum file to upload is 5MB`, // [97, 99]
    vuilongnhapdayduthongtintaikhoannganhang: `Please enter full information of beneficiary account`, // [97, 99]
    dongy: `Ok`, // [97, 99]
    huybo: `Cancel`, // [99, 100]
    thulai: `Retry`, // [99, 100]
    vuilongnhapmatkhau: `Please enter your password`, // [99, 100]
    vuilongnhaptendangnhap: `Please enter your username`, // [99, 100]
    dasaochepvaobonhodem: `Copied to cache`, // [99, 100]
    dangnhapvantaythatbai: `Fingerprint/Face login is not installed. Please login with password and check again`, // [99, 100]
    thatbai: `Touch ID sign in Fail`, // [100, 101]
    daxayraloi: `Error! Please try again later`, // [100, 101]
    matkhaucuphaikhacmatkhaumoi: `The old password must be different from the new password`, // [100, 101]
    emailcuphaikhacemailmoi: `Old email must be different from New email`, // [100, 101]
    xacnhanxoalenhgiaodich: `Confirm delete transaction order?`, // [98, 102]
    chuadutuoi: `According to regulations on age to be traded, the Fund must be at least 18 years old. We regret to reject investor registration information.`, // [98, 102]
    nhapotpquasoluong: `Wrong OTP more than 3 times. For security reasons please login again.`, // [98, 102]
    registernhapquaotp: `Your transaction has expired. Please create a new transaction`, // [98, 102]
    ekycfail: `We are unable to verify the information you are providing because the image quality is not good. Please do it again!`, // [102, 103]
    ekycfail3: `Currently, we cannot verify your information because of bad quality pictures. Please enter your personal information manually and submit to create an account.`, // [103, 104]
    dangkytaikhoanthanhcong: `You have successfully registered your account. If you need further advice, please contact (84-28) 3810 0888 - Ext: 5555 or (84) 983 070481.`, // [101, 104]
    dangnhapsai: `Invalid username or password. Please try again`, // [103, 104]
    chungminhhethan: `Your ID Card is expired `, // [104, 105]
    vuilongnhapdayduthongtin: `Please input full information`,
  },

  agentcy: {
    thongtincongtacvien: `Agency information`, // [104, 106]
    masothuecanhan: `Personal tax code`, // [106, 107]
    thuoctongdaily: `General agency`, // [106, 107]
    taihopdongcongtacvien: `Download Agency contract`, // [107, 108]
    matuvan: `Consulting code`, // [107, 108]
    content: `The Partner Contract has been confirmed with your electronic signature. To view the content of the Partner Contract that You have signed by clicking the button below.`, // [107, 108]
    content2: `Required information \n\nTo register to become a Partner, you need to fill in the above information and sign for confirmation.`, // [107, 108]
    dangkycongtacvien: `Register as a Agency`, // [107, 108]
    toidongy: `I agree to the terms and conditions on the Partner Contract`, // [108, 109]
    desau: `Later`, // [109, 110]
    kydientu: `Do Esign`, // [109, 110]
    chonloaidoitac: `Select partner type`, // [109, 110]
    loaidoitac: `Type`, // [109, 110]
    canhan: `Individual`, // [109, 110]
    trong: ` `, // [109, 110]
    dailybaohiem: `DLVN-Agency`, // [109, 110]
  },

  component: {
    ngay: `Date`,
    thang: `Month`,
    nam: `Year`,
    goiy: `Hint`,
    currency: `${stringApp.currencyEn}`,
    tren: 'Above',
    tu: 'From',
    ngaytrolen: 'days above',
    duoi: 'Below',
    nhohonhoacbang: 'Less than or equal',
    trolen: 'above',
    ngay1: 'days',
    chuaxacthuc: 'Not authenticated',
    INVESTMENT_PROFILE_PENDING: 'Pending',
    INVESTMENT_PROFILE_APPROVE: 'Approved',
    INVESTMENT_PROFILE_ACCEPT: 'Approved',
    INVESTMENT_PROFILE_REJECT: 'Reject',
    dangnhapbangvantay: `Use your Touch ID/Face ID to unlock ${stringApp.appName}`,
    dangnhapvaoapp: `Login ${stringApp.appName}`,
    daky: 'Full submission',
    chuaky: 'No submission',
    timkiemquydautu: 'Search fund',
    chuongtrinhdaututudongvalientuc:
      'programme is an automatic and continuous investment program',
    lenhmuadinhky: `- You do not need to create a buy order, but only transfer to the Funds receiving account to perform periodic buy orders`,
    luuy: 'Note',
    thoidiemnhantien: `You need to transfer money to invest for SIP of term `,
    truoc: 'before',
    kichhoatvantay: `Enable your Touch ID/Face ID for app login`,
    vantaykhuonmat: `Touch ID/Face ID for ${stringApp.appName}`,
    goi: `Call`,
    dangthamgia: `Active`,
    dadung: 'Stop',
    riskAssessment: `riskAssessmentEn`,
    huysmartotp: `Delete smart-OTP`,
    thaydoivantay: `Biometric in device has been changed, please log in again with your password !`,
  },

  changecmnd: {
    ...langEn, // [109, 110]
  },

  eventreward: {
    chuongtrinhlantoa: `Lan Toa program`, // [85, 109]
    chuongtrinhlantoacontent: `Receive ${convertNumber(
      100000,
    )} upon successfully introducing each Client to the Recurring Investment Program`, // [85, 109]
    lantoabanbevanhanthuong: `Invite friends \nand receive rewards.`, // [111, 112]
    content1: `Receive `, // [111, 112]
    diemthuong: `reward points`, // [111, 112]
    tuongduong: `equivalence`, // [111, 112]
    content2: `when introduce one Customer for joining Regular Investment Program successfully.`, // [111, 112]
    content3: `* Maximum of 5,000 bonus points per referrer`, // [111, 112]
    content4: `, details in Program Policy`, // [111, 112]
    xemquydinhchuongtrinh: 'See program policy', // [111, 112]
    tongquan: 'Overview', // [111, 112]
    tongtienthuongcuaban: 'Total reward points', // [111, 112]
    tienthuongdasudung: 'Used', // [111, 112]
    sodutienthuong: 'Remaining balance', // [111, 112]
    soluongkhachhanggioithieuhople:
      'Number of customers introduced successfully:', // [113, 114]
    uploadhinhanhgiaodich: 'Upload transaction images', // [113, 114]
    magioithieu: 'Referral code', // [113, 114]
    linkgioithieu: 'Referral link', // [113, 114]
    chiaselienket: 'Share', // [113, 114]
    xemhuongdanchitiet: 'See detailed instructions', // [113, 114]
    dautuvoitienthuong: 'Invest with bonuses', // [113, 114]
    huongdanchitiet: 'Detailed instructions', // [113, 114]
    quydinhchuongtrinh: 'Program regulations', // [113, 114]
    taianhlen: 'Upload image', // [113, 114]
    hinhanhdaupload: 'Image uploaded', // [113, 114]
    intro1: `Share referral code or link with friends.`, // [113, 114]
    intro2: `Invite them for openning account via ${stringApp.appName} and joining Regular Investment Program.`, // [87, 115]
    intro3: `The referred person uploaded the transfer order image successfully`, // [87, 115]
    intro41: `You receive `, // [87, 115]
    intro42: `when your friend qualifies the program.`, // [87, 115]
    chitietdieukhoan: 'Terms details', // [87, 115]
    datlenhmuavoitienthuong: 'Place a buy order with bonus', // [87, 115]
    taive: `Download`, // [87, 115]
    maqrgioithieu: `QR code`, // [87, 115]
  },

  investmentlibraryscreen: {
    thuviendautu: 'Investment Library', // [91, 115]
    xemthem: 'Show more', // [91, 115]
    baivietlienquan: 'Related Posts', // [91, 115]
  },
  ERROR_BE: {
    NOT_DELETE: `This is Root system account, you cannot delete`,
    CREATED: `You have registered account successfully`,
    NO_CONTENT: `Cannot found data`,
    NOT_FOUND: `Cannot found data`,
    BAD_NEW_PASSWORD: `Password includes lowercase (a-z) and uppercase  (A-Z) letters, contain at least some numbers (0-9) or special symbols and Minimum length is 6 characters`,
    CONFIRM_PASSWORD_NOT_MATCH: `The re-entered password does not match.`,
    USER_IS_INACTIVE: `Your account has not been activated. Please seek customer service for support`,
    USER_IS_WAITING_ADMIN_APPROVE: `Your account is pending KYC`,
    INVALID_OLD_EMAIL: `The current email is not match`,
    BAD_REQUEST: `The access link is not found`,
    INVALID_USER: `Username or Password is invalid`,
    INVALID_IP: `Invalid IP address. Please use the system authorized ID address`,
    CAN_NOT_SAVE_USER: `Registration account is failed, Please try again`,
    INVALID_USER_TYPE: `Invalid User Type`,
    INVALID_STATUS: `Invalid status`,
    INVALID_INVESTOR_TYPE: `Invalid Investor Type`,
    INVALID_ISSUER_TYPE: `Issued Place is invalid`,
    INVALID_DATA_PROVINCE: `Selected Province is invalid`,
    INVALID_DATA_COUNTRY: `Selected Country is invalid`,
    INVALID_ADMIN_BANK: `Bank is invalid`,
    CONFLICT_ADMIN_BANK_NUMBER: `Bank account is invalid`,
    INVALID_DATA_BANK: `Bank is invalid`,
    CONFLICT_DATA_BANK_STOCK_NAME: `Bank Code is invalid`,
    INVALID_PRODUCT: `Fund is not exist in system`,
    CONFLICT_PRODUCT_CODE: `Fund Code is not exist in system`,
    UPLOAD_CONTRACT_FAIL: `Uploading file occurred error`,
    INVALID_SEARCH_TIME: `Searching Period is invalid`,
    INVALID_MAXIMUM_PERIOD: `Maximun Period is 180 days`,
    INVALID_ORDER: `Transaction cannot found`,
    CONFLICT_ORDER_CODE: `Transaction Code cannot found`,
    INVALID_ORDER_TYPE: `Transaction Type cannot found`,
    INVALID_OTP: `OTP is invalid`,
    EXPIRED_OTP: `OTP is expired. Please click Resend OTP to get a new OTP`,
    OTP_LOCKED: `Your session is expired, please refresh and create a new transaction`,
    OTP_IS_SENT: `The one-time authentication code (OTP) that has been sent to you`,
    OTP_IS_NOT_SENT: `OTP is not sent`,
    OTP_INVALID_TRANS_ID: `Invalid OTP code`,
    INVALID_USER_STATUS: `Your session is timeout, please re-login and try again`,
    PASSWORD_NOT_MATCH: `The old password is incorrect`,
    INVALID_PRODUCT_STATUS: `Status of Fund is invalid`,
    INVALID_EMAIL_SUBJECT: `Email subject is incorrect`,
    INVALID_EMAIL: `Email format is invalid`,
    NOT_EXISTS_EMAIL: `Email is not exist`,
    EMAIL_ALREADY_REGISTERED: `The email is exist, please try with another email address`,
    INVALID_PHONE_POSTAL: `Area Code is invalid`,
    PHONE_IS_NOT_VIETNAM: 'Please use Vietnam`s Phone number',
    EMAIL_NOT_REGISTER: `Email is not exist`,
    CONFLICT_BUY_AUTO: `Your SIP transaction has registered auto-investment`,
    INVALID_ID_TYPE: `Document Type is invalid`,
    INVALID_PHOTO: `Document information is invalid`,
    INVESTMENT_PROFILE_CANT_CHANGE: `Investment Account is pending KYC or KYCED`,
    INVALID_BANK: `Beneficiary Bank is not exist`,
    INVALID_DATA_DISTRICT: `District is invalid`,
    INVALID_DATA_WARD: `Ward is invalid`,
    INVALID_USER_INFO: `Cannot found user information`,
    INVALID_ID_TYPE_FOR_USER_TYPE: `Document Type is not match with Account Type`,
    INVALID_PRODUCT_PROGRAM: `Fund Program is invalid`,
    INVALID_BUY_MONEY: `The amount must be greater or equal than the minimum subscription amount.`,
    INVALID_SELL_PROGRAM: `Fund Program is inactived`,
    INVALID_SELL_PRODUCT: `Inactive Product`,
    INVALID_SWITCH_PROGRAM:
      'This fund`s investment program does not allow conversion to other funds.',
    INVALID_BUY_SCHEME: `This Fund Program does not allow to register auto-investment`,
    INVALID_SOURCE: `Source is invalid`,
    INVALID_VOLUME: `Available Units does not enough to redeem`,
    INVALID_VOLUME_HOLDING_MIN: `Limit holding units must be equal or more than minimum holiding units`,
    INVALID_CUT_OFF_TIME: `You cannot delete this transaction because system already closed trading session`,
    INVALID_ORDER_STATUS: `Transaction already approved or submitted`,
    INVALID_TRANSACTION: `Transaction is not exist`,
    INVALID_DEST_PRODUCT: `The target fund is invalid. Please try with another target fund`,
    INVALID_SELL_DEST_PRODUCT: `Target Fund is inactivated`,
    INVALID_DES_PRODUCT_PROGRAM: `Target Fund Program is invalid`,
    INVALID_SELL_DES_PROGRAM: `Target Fund Program is inactivated`,
    INVALID_SWITCH_SAME_PROGRAM: `For switching, source program and target program must be program`,
    INVALID_VOLUME_BALANCE: `The remaining number of fund units is less than the minimum of redemption amount. Investor can sell all existing Fund units`,
    INVALID_PASSWORD: `Old password is invalid`,
    INVALID_VOLUME_SELL: `Invalid number of current Fund units.`,
    EXPORT_ERROR: `Occur error during process`,
    INVALID_APPROVE_RECEIVED_MONEY_ERROR: `Transaction Id is not exist`,
    INVALID_INVESTMENT_HARD_PROFILE: `Fund Company still not receive your hardcopy document. Please contact salesperson or call center for help`,
    INVALID_TEMPLATE: `Report template is not exist`,
    INVALID_ACCOUNT_TYPE: `Account Type is not exist`,
    INVALID_EXCEL_DATA: `File Data is not exist`,
    INVALID_TRADING_TIME: `Trading session is invalid. Please check data in import file`,
    INVALID_TRADING_TIME_FORMAT: `Trading session is invalid format`,
    INVALID_R44_APPROVE: `Occur error during process R44`,
    EXECUTED_R44: `This Fund is already proceed R44. Please check and try again`,
    INVALID_ID_NO_ACCOUNT_NO: `Document No or Account no is invalid`,
    ID_NO_ALREADY_REGISTERED: `Duplicate document information. Please check and try again`,
    INVALID_CHANNEL: `Can not delete. Invalid distribution channel`,
    INVALID_IMAGE_TYPE: `The signature image you uploaded is not in the correct format. Please select image files with the format extention (.png,.jpg, .gif, .jpeg)`,
    SIGN_ERROR: `Error occurs during processing. Please try again`,
    SIGNATURE: `FULL SUBMISSION`,
    INVALID_SWTICH_BUY_MONEY: `Subscription amount is less than the minimum subscription amount of the Target Fund`,
    INVALID_VOLUME_BALANCE_LIMO: `Invalid number of current Fund units. Investor can only sell all or partial amount (minimum balance at least is at 100 Fund units)`,
    INVALID_SWITCH_VOLUME_BALANCE_LIMO: `Invalid number of current Fund units.`,
    CLIENT_ID_NOT_EXISTED: `Cliend ID Not Existed`,
    INVALID_TRANSACTION_FILTER: `Invalid transaction filter. Select the source and period of time for the upcoming transaction`,
    INVALID_TRADING_TIME_EXPORT_FORMAT: `Invalid Trading Time Export Format`,
    INVALID_SWITCH_SAME_PRODUCT: `Invalid swtiching order`,
    INVALID_PERMANENT_ADDRESS_INFO: `Permanent address is invalid`,
    INVALID_MAILING_ADDRESS_INFO: `Contact address is invalid`,
    INVALID_DEVICE_INFO: `Device INVALID code`,
    REQUIRED_PRODUCT: `Product is invalid`,
    REQUIRED_PROGRAM: `Program is invalid`,
    REQUIRED_FEE_TYPE_CODE: `Fee type code is invalid`,
    UNAUTHENTICATED: `Unauthorized`,
    UNAUTHORIZED: `Unauthorized`,
    FORBIDDEN: `No permission to access`,
    CONFLICT_USER_EMAIL: `This email is already exist`,
    INVALID_FORMAT_FILE: `Invalid Format File`,
    DELETED_BUY_AUTO: `Your SIP is expired`,
    RECONCILED_BUY_AUTO: `Your SIP already summit for this current trading session`,
    VALIDATE_KYC: `Account has not been approved`,
    INVALID_HOLDING_PEROID: `Invalid Holding Peroid`,
    INVALID_OBJECT: `Invalid Object`,
    INVALID_INVESTMENT_POLICY: `Invalid Investment Policy`,
    POLICY_REQUEST_CANCEL: `Cancel request  submitted `,
    INTERNAL_SERVER_ERROR: `Occur error during loading data`,
    OTP_DELIVERY_ERROR: `OTP Delivery Error`,
    EXTERNAL_SERVICE_FAIL: `External Service Fail`,
    INVALID_USERNAME: `Invalid Username`,
    FIRE_BASE_CONFIG_NOT_FOUND: `The configuration file of FireBase not found or invalid`,
    TIMER_DATE_MUST_GREATER_CURRENT_DATE: `Timer date must be greater than current date`,
    NOT_FOUND_DEVICE_TOKEN: `The device token not found`,
    NOT_FOUND_NOTIFICATION: `The notification not found`,
    CANNOT_UPDATE_NOTIFICATION_DONE: `Cannot update the notification has been done`,
    NOT_TIMER_NOTIFICATION: `This notification is not the timer notification`,
    TIMER_EXPIRED_CANNOT_UPDATE_NOTIFICATION: `The timer is expired. Cannot update the notification`,
    NOT_FOUND_USER_INBOX: `This inbox message not found`,
    IPO_FUNDS_IS_NOT_ESGIN:
      'Please sign the INVESTOR ` WRITTEN OPINION LETTER to be able to place subscription order during the IPO',
    IPO_FUNDS_IS_NOT_EXIST: `IPO Fund is Not Exits`,
    INVALID_USER_REF_CODE: `Referal code is invalid`,
    INVALID_SELL_VOLUME: `Redemption Units must be equal or more than Minimum units`,
    INVALID_USER_BANK_ACCOUNT: `Invalid bank information`,
    INVALID_CONFIRM_TOKEN: `Invalid OTP code`,
    CAN_NOT_DELETE_INVESTOR: `Can not delete. Investor `,
    INVALID_INVESTMENT_PROFILE: `Investment Account is not existed or is pending KYC`,
    CONFLICT_ID_NO: `Document No is exist`,
    PHONE_ALREADY_REGISTERED: `The phone number is exist. Please try with another phone number`,
    INVALID_ID: `Document No is invalid`,
    INVALID_PHONE: `Invalid Phone number`,
    USER_ADDITIONAL_INFO_PROFESSIONAL: `Please contact the agent for additional application`,
    FATCA_NONE_ESIGN: `Please check again the FATCA status. Lighthouse Capital will contact investors to supplement documents.`,
    TRANSACTION_VALIDATE_KYC: `Please effectuate eSign to complete the opening trading account process.`,
    TRANSACTION_VALIDATE_APPROVE: `Your account is pending approval. Investors cannot make any transactions during this period.`,
    USING_OTHER_DEVICE_SMART_OTP: `Investor login on another divice. Please registered Smart OTP on new device`,
    INVESTMENT_PROFILE_APPROVE_EKYC: `You have successfully registered an account. If you need further advice, please contact us at (84-28) 3810 0888 - Ext: 5555 or (84) 983 070481.`,
    hoacquykhachtaitaiday: `or you can download here`,
    INVESTMENT_PROFILE_PENDING_EKYC: `You have successfully registered an account. If you need further advice, please contact us at (84-28) 3810 0888 - Ext: 5555 or (84) 983 070481.`,
    INVALID_CHANGE_ID_NO: `Your Identity Card isn't change. Please check your information and try again`,
    INVALID_OBJECT_CHANGE_ID_NO: `Your Identity Card is valid, your Identity Card isn't change`,
    INVALID_INPUT: `Invalid input`,
    DISABLE_TRANSACTION_OLD_ID_NO: `Please update your ID to proceed with the order.  For assistance, you can contact number: 028.3810.0888 - Ext: 5555 or 0983070481. Or visit the https://dfvn.com.vn/vi/node/4182 to see instructions for updating ID`,
    INVALID_OLD_ID_NO:
      'Your Identity Card is invalid. Please use a valid Citizen Identification Card to proceed.',
  },
};
